import { z } from 'zod';
import type { ThemeTemplateToken } from '@sleed/bizcommerce-api';

/**
 * Theme template edit form. Mirrors `ThemeTemplateToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Catalog/ThemeTemplates/index.js): nm required ≤200, cd required ≤100,
 * isfp (is-for-products) + isfc (is-for-categories) booleans. iv/si are not surfaced by the legacy grid
 * but are carried through so edits preserve them. The scope-mapping endpoints (GetByScope/InsertByScope)
 * are consumed on the product/category editors, not on this list page.
 */
export const themeTemplateSchema = z.object({
	id: z.number().optional(),
	nm: z.string().trim().min(1, 'validation.required').max(200, 'validation.tooLong'),
	cd: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	isfp: z.boolean(),
	isfc: z.boolean(),
	iv: z.boolean(),
	si: z.number().int()
});

export type ThemeTemplateFormValues = z.infer<typeof themeTemplateSchema>;

export const EMPTY_THEME_TEMPLATE: ThemeTemplateFormValues = {
	nm: '',
	cd: '',
	isfp: false,
	isfc: false,
	iv: true,
	si: 0
};

export function tokenToForm(token: ThemeTemplateToken): ThemeTemplateFormValues {
	return {
		id: token.id,
		nm: token.nm ?? '',
		cd: token.cd ?? '',
		isfp: token.isfp ?? false,
		isfc: token.isfc ?? false,
		iv: token.iv ?? true,
		si: token.si ?? 0
	};
}

export function formToToken(form: ThemeTemplateFormValues): ThemeTemplateToken {
	return {
		id: form.id,
		nm: form.nm.trim(),
		cd: form.cd.trim(),
		isfp: form.isfp,
		isfc: form.isfc,
		iv: form.iv,
		si: form.si
	};
}
